class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });

    // Clicking the dimmed backdrop closes the modal, the panel itself does not.
    this.querySelector('.modal__content').addEventListener('click', (event) => {
      if (event.target === event.currentTarget) this.close();
    });
  }
}

customElements.define('password-modal', PasswordModal);
